<!-- @format -->
<template>
    <div class="entry-div">
        <div class="title-bar">
            <div class="title-text">Send DateSheet ({{ moptn }})</div>
            <div class="close-btn" @click="closeIt">
                <span class="fas fa-times-circle"></span>
            </div>
        </div>

        <card-loader :LoaderText="loaderText" v-show="loading == true"></card-loader>
        <div class="div-content" v-show="loading == false">
            <alert-box :alertText="alertMsg" :alertType="errType" v-if="alert"></alert-box>

            <div ref="entryform">
                <div class="err" v-if="err">{{ errMsg }}</div>

                <label for="class">
                    Select Class:
                    <MandatoryPage />
                </label>
                <select name="cldes" class="form-select" v-model="Cmbcldes" tabindex="1" ref="class">
                    <option :value="{ id: '', text: '', text1: '' }">--Select--</option>
                    <option v-for="item in Classes" :key="item.class" :value="{
                        id: item.class,
                        text: item.cldes,
                        text1: item.class1,
                    }">
                        {{ item.cldes }}
                    </option>
                </select>

                <label for="uplfile">Upload File :</label>
                <upload-file @file-select="getFile" ref="uploadfile"></upload-file>
            </div>
            <div class="btn-div">
                <button type="button" class="btn btn-success" tabindex="2" @click="saveRec">
                    Save
                </button>
                <button type="button" class="btn btn-danger" tabindex="3" @click="closeIt">
                    Cancel
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import AlertBox from "@/components/AlertBox.vue";
import UploadFile from "@/components/UploadFile.vue";

export default {
    components: {
        AlertBox,
        UploadFile,
    },
    emits: ["close-btn"],
    props: {
        moptn: {
            type: String,
            default: "Add",
            required: false,
        },
    },
    data() {
        return {
            formData: {
                docno: "",
                filename: "",
                fileicon: "",
                filepath: "",
            },
            Cmbcldes: { id: "", text: "", text1: "" },
            userId: this.$store.state.userId,
            userName: this.$store.state.userName,
            err: false,
            errMsg: "",
            errType: "",
            alertMsg: "",
            alert: false,
            loading: false,
            Classes: [],
            loaderText: "Saving",
            selectedfile: null,
            upload_directory: "datesheet",
            trackno: 0,
        };
    },
    methods: {
        activateForm() {
            setTimeout(() => {
                if (this.$refs.class) {
                    this.$refs.class.focus();
                }
            }, 100);
        },
        closeIt() {
            this.$emit("close-btn");
        },
        getFile(xfile) {
            this.selectedfile = xfile;
        },
        async uploadFile() {
            var success = true;
            if (this.selectedfile != null) {
                const formData = new FormData();
                formData.append("dir", this.upload_directory);
                formData.append("files[]", this.selectedfile);
                await axios
                    .post("uploadfiles.php", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then((resp) => {
                        if (resp.data.Errorsts == false) {
                            this.formData.filename = resp.data.Files[0];
                        } else {
                            success = false;
                            alert(resp.data.ErrorMsg);
                        }
                    });
                this.$refs.uploadfile.clearImage();
            }
            return success;
        },
        async saveRec() {
            this.loading = true;
            this.loaderText = "Saving";
            this.formData.filepath = this.$store.state.filePath;

            var msg = "";
            if (this.Cmbcldes.id == "") {
                msg = "Please Select Class !!";
                this.errMsg = msg;
                this.err = true;
                this.loading = false;
                this.$refs.class.focus();
                return;
            }

            this.err = false;
            var filesuccess = await this.uploadFile();
            if (filesuccess == true) {
                var sendData = { ...this.formData };
                sendData.class = this.Cmbcldes.id;
                sendData.class1 = this.Cmbcldes.text1;
                sendData.cldes = this.Cmbcldes.text;

                await axios
                    .post("datesheet.php", {
                        optn: this.moptn,
                        frmdata: sendData,
                        userid: this.userId,
                        username: this.userName,
                        mtrackno: this.trackno,
                    })
                    .then(async (response) => {
                        var resp = response.data;
                        if (resp.Errorsts == true) {
                            this.err = true;
                            this.errMsg = "Something went Wrong " + resp.ErrorMsg;
                        } else {
                            this.showAlert();
                            this.alertMsg = "Saved";
                            this.errType = "success";
                            this.$refs.uploadfile.clearImage();
                            this.selectedfile = null;
                            this.formBlank();
                            if (this.moptn == "Edit") {
                                setTimeout(() => {
                                    this.closeIt();
                                }, 1000);
                            }
                        }
                    });
            }
            this.loading = false;
        },
        formBlank() {
            this.errMsg = "";
            this.err = false;

            var self = this;
            Object.keys(this.formData).forEach(function (key) {
                self.formData[key] = "";
            });
            this.Cmbcldes = { id: "", text: "", text1: "" };
            this.selectedfile = null;
            if (this.$refs.uploadfile) {
                this.$refs.uploadfile.clearImage();
            }
            this.activateForm();
        },
        showAlert(xtime = 1500) {
            this.alert = true;
            setTimeout(() => {
                this.alert = false;
            }, xtime);
        },
        async fillRec(xrecid) {
            this.trackno = xrecid;
            var mstData = "";
            await axios
                .post("datesheet.php", {
                    optn: "Getrec",
                    trackno: xrecid,
                })
                .then((response) => {
                    var resp = response.data;
                    mstData = resp.List;
                });

            Object.keys(this.formData).forEach((key) => {
                this.formData[key] = mstData[0][key];
            });
            this.Cmbcldes.id = mstData[0]["class"];
            this.Cmbcldes.text = mstData[0]["cldes"];
            this.Cmbcldes.text1 = mstData[0]["class1"];

            this.activateForm();
            this.errMsg = "";
            this.err = false;
        },
        async getClasses() {
            var q1 = "";
            if (this.$store.state.isTeacher == true) {
                q1 =
                    "WHERE EXISTS (select class,class1 from userclasses_view c " +
                    "where a.class=c.class and a.class1=c.class1 and c.uid='" +
                    this.userId +
                    "' group by c.class,c.class1)";
            }

            var q =
                "select a.class,a.class1,a.cldes,a.ord " +
                "from classes a " +
                q1 +
                " order by a.ord";
            await axios
                .post("getjson.php", {
                    optn: "GetData",
                    qry: q,
                })
                .then((response) => {
                    var resp = response.data;
                    if (resp.Errorsts == false) {
                        this.Classes = resp.List;
                    } else {
                        console.log("Error:" + resp.ErrorMsg);
                    }
                });
        },
    },
    async mounted() {
        this.loading = true;
        this.formBlank();
        await this.getClasses();
        this.loading = false;
    },
};
</script>

<style>
@import "./css/master.css";
</style>
<style scoped>
.textbox {
    resize: none;
}
</style>
